import { useEffect, useState } from "react";
import { throttle } from "utils/throttle";

export const useOffsetTop = () => {
  const [offsetOpt, setOffsetTop] = useState(0);

  useEffect(() => {
    const layout = document.querySelector("#profile-layout");
    const handler = throttle(() => {
      setOffsetTop(layout?.scrollTop ?? 0);
    }, 100);

    layout?.addEventListener("scroll", handler);

    return () => {
      layout?.removeEventListener("scroll", handler);
    };
  }, [offsetOpt]);

  return offsetOpt;
};
